import { PersonOutlined } from "@mui/icons-material";
import clsx from "clsx";
import { FC, ReactNode } from "react";

import { FramerTooltip } from "@ryde/controls";

export interface ICoursesCalendarCellPassengersBadgeProps {
  onRide: number;
  notOnRide: number;
  showRatio: boolean;
  modifierClass: string;
  tooltip: ReactNode;
  tooltipDisabled?: boolean;
}

export const CoursesCalendarCellPassengersBadge: FC<
  ICoursesCalendarCellPassengersBadgeProps
> = ({
  onRide,
  notOnRide,
  showRatio,
  modifierClass,
  tooltip,
  tooltipDisabled,
}) => (
  <FramerTooltip content={tooltip} tooltipDisabled={tooltipDisabled}>
    <span className={clsx("cc-passengers-pill", modifierClass)}>
      <PersonOutlined
        className="cc-passengers-pill__icon"
        sx={{ color: "inherit", fontSize: "inherit" }}
      />
      {showRatio ? (
        <span className="cc-passengers-pill__ratio">
          <span className="cc-passengers-pill__count">{onRide}</span>
          <span className="cc-passengers-pill__sep">/</span>
          <span className="cc-passengers-pill__count">{notOnRide}</span>
        </span>
      ) : (
        <span className="cc-passengers-pill__count">{notOnRide}</span>
      )}
    </span>
  </FramerTooltip>
);
